// src/pages/Historico/utils/sensorDetection.js
import { GraficoTipo } from '../../../infra/api/GraficoApi';

export const SPECTRAL_CHART_TYPES = new Set([
    GraficoTipo.SPECTRAL_TURBIDIMETRY,
    GraficoTipo.SPECTRAL_NEPHELOMETRY,
    GraficoTipo.SPECTRAL_FLUORESCENCE,
]);

const SENSOR_CHANNELS = {
    AS7341: ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'clear', 'nir'],
    APDS9960: ['red', 'green', 'blue', 'clear'],
};

/**
 * Detecta o tipo de sensor a partir do experiment ou dos dados do gráfico.
 */
export function detectSensorType(activeTab, experiment, chartData) {
    if (!SPECTRAL_CHART_TYPES.has(activeTab)) return null;

    // 1) Tenta via experiment.spectral
    if (experiment?.spectral) {
        const spectralKey = activeTab.toLowerCase().split('_')[1];
        const fromExp = experiment.spectral[spectralKey]?.sensorType;
        if (fromExp) return fromExp;
    }

    // 2) Tenta via séries do gráfico
    if (chartData?.series) {
        const seriesList = Object.values(chartData.series)[0] || [];
        const names = seriesList.map(s => s.name.toLowerCase());

        const hasAS7341 = ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8']
            .every(ch => names.some(n => n.endsWith(`.${ch}`) || n.endsWith(ch) || n === ch));

        const hasAPDS9960 = ['red', 'green', 'blue', 'clear']
            .every(ch => names.some(n => n.endsWith(`.${ch}`) || n.endsWith(ch) || n === ch.charAt(0)));

        if (hasAS7341) return 'AS7341';
        if (hasAPDS9960) return 'APDS9960';
    }

    return null;
}

/**
 * Filtra séries do gráfico para manter apenas canais do sensor detectado.
 */
export function filterDataBySensor(data, chartKey, experiment) {
    if (!data?.series || !SPECTRAL_CHART_TYPES.has(chartKey)) return data;

    const sensorType = detectSensorType(chartKey, experiment, data);
    if (!sensorType || !SENSOR_CHANNELS[sensorType]) return data;

    const allowedChannels = SENSOR_CHANNELS[sensorType];
    const filteredSeries = {};

    for (const [groupKey, seriesArray] of Object.entries(data.series)) {
        if (!Array.isArray(seriesArray)) {
            filteredSeries[groupKey] = seriesArray;
            continue;
        }
        filteredSeries[groupKey] = seriesArray.filter(serie => {
            const sName = serie.name.toLowerCase();
            return allowedChannels.some(ch =>
                sName === ch || sName.endsWith(`.${ch}`) || sName.endsWith(ch)
            );
        });
    }

    return { ...data, series: filteredSeries };
}
